import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49c1b96f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-tabs flex" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "tabs-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "active-bg" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_billDetail0 = _resolveComponent("billDetail0")!
  const _component_billDetail1 = _resolveComponent("billDetail1")!
  const _component_billDetail2 = _resolveComponent("billDetail2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("li", {
          key: tab.value,
          onClick: ($event: any) => (_ctx.tabClick(tab.value)),
          class: _normalizeClass({ active: _ctx.formData.type === tab.value })
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(tab.label), 1),
          _hoisted_4
        ], 10, _hoisted_2))
      }), 128))
    ]),
    (_ctx.formData.type=='0')
      ? (_openBlock(), _createBlock(_component_billDetail0, {
          key: 0,
          initForm: _ctx.route.query
        }, null, 8, ["initForm"]))
      : _createCommentVNode("", true),
    (_ctx.formData.type=='1')
      ? (_openBlock(), _createBlock(_component_billDetail1, {
          key: 1,
          initForm: _ctx.route.query
        }, null, 8, ["initForm"]))
      : _createCommentVNode("", true),
    (_ctx.formData.type=='2')
      ? (_openBlock(), _createBlock(_component_billDetail2, {
          key: 2,
          initForm: _ctx.route.query
        }, null, 8, ["initForm"]))
      : _createCommentVNode("", true)
  ], 64))
}